import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-reset",
  templateUrl: "./med-icon-reset.component.html",
})
export class MedIconResetComponent extends SvgMixinComponent {}
